<template>
  <div class="md-layout anonymoousorder" :class="!argqrId ? 'maxwidth':'withiphone'">

    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" :class="subdomain">
      
   
      <div id="menu" class="md-layout-item md-size-100 md-medium-size-100">
        <md-card>   
          
          <div class="md-layout-item float-right" v-if="languages !== undefined && languages.length > 0">
           <div class="language-switcher float-right" v-if="languages.length > 1">
            <div class="language-select languages border-radius" >
              <md-field>
                <md-select  v-model="selectedLanguage" @md-selected="switchLanguage" >
                  <md-option v-for="lang in languages" :key="lang.codelowercase" :value="lang.codelowercase">
                    {{ lang.name }} {{ lang.flag }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          </div>

          <div class="linkcontainer">
              <span class="ml-2 instagram" v-if="menu.stablishment && menu.stablishment.instagram" >
                <a :href="menu.stablishment.instagram" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0C5.829 0 5.556.01 4.703.048C3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7C.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297c.04.852.174 1.433.372 1.942c.205.526.478.972.923 1.417c.444.445.89.719 1.416.923c.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417c.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046c.78.035 1.204.166 1.486.275c.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485c.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598c-.28.11-.704.24-1.485.276c-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598a2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485c-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486c.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276c.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92a.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217a4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334"/></svg>
                </a>
              </span>
              <span class="ml-2 website" v-if="menu.stablishment &&  menu.stablishment.website">
                    <a :href="menu.stablishment.website" target="_blank">
                    <svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 107.366 107.366" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path style="fill:#010002;" d="M107.366,53.683C107.366,24.082,83.283,0,53.683,0c-4.982,0-9.785,0.734-14.366,2.011L39.21,1.94 c-0.025,0.036-0.043,0.075-0.068,0.115C16.595,8.417,0,29.125,0,53.683c0,29.601,24.082,53.683,53.683,53.683 c4.985,0,9.785-0.734,14.366-2.011l0.107,0.075c0.025-0.036,0.047-0.075,0.068-0.115C90.77,98.948,107.366,78.237,107.366,53.683z M5.343,56.292H24.69c0.193,5.766,0.837,11.438,2.004,16.942H9.366C7.047,68.002,5.662,62.29,5.343,56.292z M102.022,51.077H82.679 c-0.197-5.769-0.837-11.442-2.008-16.946H98C100.319,39.364,101.704,45.076,102.022,51.077z M77.468,51.077h-21.18V34.131h19.061 C76.58,39.625,77.264,45.298,77.468,51.077z M56.292,28.924V5.343c2.53,0.136,5.014,0.415,7.43,0.923 c4.502,6.986,7.97,14.595,10.289,22.658H56.292z M51.077,28.924h-18.12c2.137-7.92,5.354-15.436,9.57-22.368 c2.766-0.655,5.622-1.056,8.55-1.213V28.924z M51.077,34.132v16.946H29.84c0.111-5.766,0.712-11.442,1.85-16.946H51.077z M24.633,51.077H5.34c0.319-6.002,1.704-11.717,4.023-16.946h17.046C25.335,39.654,24.741,45.319,24.633,51.077z M29.898,56.292 h21.18v16.942H32.013C30.785,67.74,30.102,62.068,29.898,56.292z M51.077,78.441v23.581c-2.53-0.136-5.018-0.415-7.43-0.923 c-4.502-6.986-7.97-14.595-10.293-22.658C33.355,78.441,51.077,78.441,51.077,78.441z M56.292,78.441h18.116 c-2.14,7.92-5.354,15.432-9.57,22.368c-2.766,0.659-5.622,1.056-8.55,1.213V78.441H56.292z M56.292,73.234V56.292h21.237 c-0.111,5.762-0.712,11.438-1.854,16.942C75.675,73.234,56.292,73.234,56.292,73.234z M82.732,56.292h19.294 c-0.319,6.002-1.704,11.714-4.023,16.942H80.957C82.031,67.712,82.625,62.047,82.732,56.292z M95.28,28.924H79.393 c-1.943-7.147-4.681-13.993-8.235-20.403C81.294,12.454,89.765,19.694,95.28,28.924z M35.219,8.883 c-3.31,6.32-5.848,13.041-7.627,20.038H12.086C17.425,19.991,25.514,12.898,35.219,8.883z M12.086,78.441h15.89 c1.94,7.147,4.678,13.993,8.231,20.403C26.072,94.911,17.601,87.671,12.086,78.441z M72.146,98.483 c3.31-6.32,5.848-13.041,7.627-20.038H95.28C89.94,87.374,81.852,94.467,72.146,98.483z"></path> </g> </g></svg>
                    </a>
              </span>
            </div>
          <div v-if="menu.stablishment !== undefined && menu.stablishment.coverImage" class="w-100 mb-1"
            id="coverimagelogo">
            <img  :src="menu.stablishment.coverImage" class="w-100 coverimage" />
            <div  class="logorestocontainer">  
              <div class="logoresto" :style="'background:url('+menu.stablishment.logo+')'">
              </div>  
            </div>   
          </div>
          <md-card-content>
             <div class="md-layout ">
              <div v-if="false" class="md-layout-item float-left md-size-100  logotitle align-center">
                  <h4 v-if="menu.stablishment !== undefined && menu.stablishment.name"  class="titlemenu" :style="'color:'+stablishment.secondaryColor">{{ menu.stablishment.name }} 
                   </h4>
              </div>
            <md-card class=" mb-4 resumecount" v-if="menu.menuType == 'onsite' && pendingOrders !== undefined && pendingOrders.length > 0">
            <md-card-content>
          <div class="w-100">
          <h3 class="float-left">{{$t('toPay')}} <small class="text-secondary">{{qrName}}</small></h3> 
          <h3 class="float-right">{{this.totalPriceOrders}} {{currencySymbol}}</h3>
          </div>
          <div class="w-100 float-left resumecount">
          <collapse
           
              id="collapsetotal23"
              :collapse="[$t('details')]"
              icon="keyboard_arrow_up"
              :open="false"
              class="bg-white">
               <template slot="md-collapse-pane-1">
              <md-table v-model="pendingOrders" table-header-color="green">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  
                  <md-table-cell>
                    <div  :class="item.payed ? 'paid':''" v-for="product in item.products" :key="product._id" class="mt-1">
                      <span class="badge bg-secondary">{{ product.quantity }}</span> <span> {{ product.product.name }} </span>
                       = 
                      <span>
                        {{ product.quantity * product.product.price }} 
                        <span v-if="item.currency">{{currencySymbol}}</span>
                      </span> 
                      <small class="paidlabel" v-if="item.payed">{{$t('yespaid')}}</small>
                      
                    </div>
                  </md-table-cell>
                </md-table-row>
              </md-table>
             </template>
              </collapse> 
            </div>
            </md-card-content>
            </md-card>   
             </div>

              <div class="checkout w-100 mb-4" v-if="sum() > 0">
                  <div>
                  <md-card>   
                    <md-card-content class="">
                      <collapse
                        id="collapsetotal"
                        :collapse="[getTerm('total') + ' ' + sum() + ' ' + currencySymbol]"
                        icon="keyboard_arrow_up"
                        :open.sync="opencollapse">
                        <template slot="md-collapse-pane-1" v-if="cart.length > 0">
                        
                        <div>
                        <collapse
                        id="collapsetotal23"
                        :collapse="[getTerm('myOrder')]"
                        iconlabel="shopping_cart"
                        icon="keyboard_arrow_up"
                        :open="false">
                           <template slot="md-collapse-pane-1">
                            <div class="text-secondary">
                              <div class="md-item-layout mb-3">
                                <div v-for="item in cart" :key="item.id" class="w-100 mt-2"> 
                                  <small><span class="btn btn-sm text-white ml-4" :style="buttonStyle(stablishment.secondaryColor)">{{ item.quantity }} x {{ item.price }}{{ currencySymbol }}</span> 
                                  {{ item.name }}  </small>
                                </div>


                                <div v-if="business.shippingCostPrice && menu.menuType == 'shipping'" class="w-100 mt-2"> 
                                  <small><span class="btn btn-sm text-white ml-4" :style="buttonStyle(stablishment.secondaryColor)">{{ business.shippingCostPrice }}{{ currencySymbol }}</span> 
                                  Costo de envío</small>
                                </div>

                              </div>
                            </div>
                            </template>
                            </collapse>


                            <strong class="text-secondary mt-4" v-if="menu.menuType != 'onsite'">{{ getTerm('orderNotification') }}</strong>

                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100">
                                <md-field>
                                  <label>{{ getTerm('name') }}</label>
                                  <md-input v-model="customerName" :placeholder="getTerm('enterName')+'*'" required></md-input>
                                </md-field>
                              </div>
                              <div class="md-layout-item md-medium-size-100" v-if="menu.requestAdditionalInfo">
                                <md-field>
                                  <label>{{ getTerm('email') }}</label>
                                  <md-input type="email" v-model="customerEmail" :placeholder="getTerm('enterEmail')+'*'" required></md-input>
                                </md-field>
                              </div>
                            </div>
                            <md-field>
                              <label>{{ getTerm('comments') }}</label>
                              <md-input type="text" v-model="customerComments" :placeholder="getTerm('enterComments')"></md-input>
                            </md-field>
                            <div class="swal2-input-group"  v-if="menu.requestAdditionalInfo">
                              <md-field style="width: 100px; display: inline-block;">
                                <label>{{ getTerm('code') }}</label>
                                <md-select v-model="selectedCountryCode" required>
                                  <md-option v-for="country in countryCodes" :key="country.code" :value="country.code">
                                     {{ country.code }} {{ country.flag }} {{ country.name }} 
                                  </md-option>
                                </md-select>
                              </md-field>
                              <md-field style="width: calc(100% - 100px); display: inline-block;">
                                <label>{{ getTerm('phone') }}</label>
                                <md-input type="tel" v-model="customerPhone" :placeholder="getTerm('enterPhone')" required></md-input>
                              </md-field>
                              <div v-if=" menu.menuType == 'shipping'"  class="my-3">
                                <label>Dirección de envío</label>
                                <div class="card p-2">
                                  <div class="md-layout">
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>Número de puerta</label>
                                        <md-input type="text" v-model="address.number" :placeholder="'Número de puerta*'" required></md-input>
                                      </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>Calle</label>
                                        <md-input type="text" v-model="address.street" :placeholder="'Calle*'" required></md-input>
                                      </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>Ciudad</label>
                                        <md-input type="text" v-model="address.city" :placeholder="'Ciudad*'" required></md-input>
                                      </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>Código postal</label>
                                        <md-input type="text" v-model="address.codepostal" :placeholder="'Código postal*'" required></md-input>
                                      </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>Provincia/Región</label>
                                        <md-input type="text" v-model="address.province" :placeholder="'Provincia/Región*'" required></md-input>
                                      </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                       <md-field>
                                          <label>País</label>
                                          <md-select v-model="address.country" required>
                                            <md-option v-for="country in countryCodes" :key="country.code" :value="country.name">
                                               {{ country.flag }} {{ country.name }} 
                                            </md-option>
                                          </md-select>
                                        </md-field>
                                    </div>
                                    <div class="md-layout-item md-size-100">
                                      <md-field>
                                        <label>TAX ID</label>
                                        <md-input type="text" v-model="address.taxid" :placeholder="'TAX ID'" required></md-input>
                                      </md-field>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </div>
                        </template>
                      </collapse>
                          <md-button 
                            class="w-100"
                            :style="buttonStyle(stablishment.primaryColor)" 
                            :disabled="!isFormValid || sum() == 0" 
                            @click="confirm">
                            <span class="md-label">
                              <md-icon class="material-icons">add_shopping_cart</md-icon>
                            </span> {{ getTerm('confirmOrder') }} {{ sum() }} {{ currencySymbol }}
                          </md-button>
                    </md-card-content>
                    </md-card>   
                  </div>
                </div>


               <div id="slidericons" class="pb-1" v-if="menu.menuType !== 'imagemenu'">
               <div id="slidericonsinner">
                  <span
                    v-for="(cat, key) in categories"
                    :key="key"
                    @click="setActiveCategory(key)"
                    ref="categoryItem"
                    class="py-2 px-3 cursor-pointer"
                    :class="{ 'active-category': activeCategory === key }"
                  >
                  <div class="text-center w-100" v-if="cat.icon">
                    <img :src="cat.icon" style="width:30px;margin-right:5px;margin-top:-5px" alt="Icon Image" />
                  </div>
                    <span class="ml-2">{{ getTranslatedName(cat) }}</span>
                  </span>
                </div>
              </div>
                <div  v-if="menu.menuType == 'imagemenu'">
                  <img v-for="img in menu.menuImages" class="imagemenu" :src="img" v-if="!isPdfByUrl(img)" />

                  <iframe class="pdfembed" v-for="img in menu.menuImages" :src="img+'#toolbar=0&navpanes=0&scrollbar=0'" type="application/pdf" width="100%" height="900px" v-if="isPdfByUrl(img)"  />

                </div>
                <div v-for="(cat, key) in categories"   v-if="menu.menuType !== 'imagemenu'"
                :key="key" class="mt-4 md-no-head float-left w-100" v-show="activeCategory === key">
                  <md-table :key="cat.id" v-model="cat.products" @md-selected="onSelect" >
                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-auto-select>
                      <md-table-cell class="tab-column">
                        <strong>{{ getTranslatedName(item) }}</strong>
                        <p>{{ getTranslatedDescription(item) }}</p>
                        <span>{{ item.price }} {{ currencySymbol }}</span>
                      </md-table-cell>
                      <md-table-cell>
                        <div class="md-layout-item">
                          <div class="picture">
                            <img class="img" :src="item.img" v-if="item.img"/>
                          </div>
                        </div>
                      </md-table-cell>
                      <md-table-cell>
                        <div class="quantity-control" v-if="menu.menuType !== 'onlymenu' && !menuDisabled">
                          <md-button @click="removeItem(item)" class="large-button md-icon-button full-height">
                            <md-icon class="material-icons">remove</md-icon>
                          </md-button>
                          <span class="quantity">{{ item.quantity }}</span>
                          <md-button @click="addItem(item)" class="large-button md-icon-button full-height" :style="buttonStyle(stablishment.primaryColor)">
                            <md-icon class="material-icons">add</md-icon>
                          </md-button>
                        </div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
          </md-card-content>

          <div class="bg-white card p-2 termsanonymous text-center">
            <a  href="https://gotake.it" target="_blank" class="mb-2 text-center ">
            <img :src="'/img/gotakeit.png'" width="80px" title="" class=" mr-2" style="width:80px;margin:0 auto;" /></a>
            <small class="text-secondary">{{$t('consentNotice')}} 
              <strong><a  class="text-primary" href="/terms" target="_blank" >{{ $t('termsLinkText') }}</a></strong></small>
          </div>
        </md-card>
      </div>
    </div>  
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Collapse } from "@/components";
import { menuAction } from "@/pages/Auth/actions";
import { createAction,notifOnAction } from "@/pages/Orders/actions";
import { i18n } from '@/i18n';
import { format } from 'date-fns';


export default {
  components: {
    Collapse
  },
  props: {
    argqrId: String
  },
  data() {
    return {
      subdomain: false,
      address: {
          number:'',
          street:'',
          city:'',
          province:'',
          country:'',
          codepostal:'',
          taxid: ''
      },
      token:false,
      soundEnabled:false,
      menuDisabled:false,
      qrId:false,
      qrName:false,
      totalPriceOrders:0,
      pendingOrders:false,
      activeCategory: 0,
      business: false,
      opencollapse: false,
      opencollapsefirst: true,
      stablishment: false,
      menu: false,
      selected: [],
      cart: [],
      countryCodes: [],
      categorieslabels: [],
      responsive: false,
      categories: [],
      customerName: '',
      customerEmail: '',
      customerPhone: '',
      customerComments: '',
      selectedCountryCode: '+34',
      selectedLanguage: 'en', // Idioma seleccionado por defecto
      terms: []
    };
  },
  watch: {
    isCollapseOpen(newVal) {
      this.opencollapse = newVal;
    }
  },
  computed: {
    currencySymbol() {
      const selectedCurrency = this.$currencies.find(option => option.value === this.business.currency);
      return selectedCurrency ? selectedCurrency.symbol : '';
    },
    languages() {
      // Suponiendo que menu.menuLanguages es un array de códigos de idiomas, por ejemplo: ['EN', 'FR', 'ES']
      const menuLanguages = this.menu.menuLanguages;
      if(menuLanguages == undefined){
        return this.$languages
      }
      // Filtra los idiomas para que solo incluya aquellos cuyos códigos están en menuLanguages
      return this.$languages.filter(language => menuLanguages.includes(language.codelowercase));
    },
    isFormValid() {
      let address = true;
      if(this.menu.menuType == 'shipping'){
        address = this.address.number && this.address.street  && this.address.city && this.address.codepostal 

      }

      if(this.menu.requestAdditionalInfo){
            return address && this.customerName && this.customerEmail && this.customerPhone && this.isValidEmail(this.customerEmail);
      }else{
        return address && this.customerName;
      }
    }
  },
  created() {
    if(this.argqrId){
      this.$route.params.id = this.argqrId
    }

    this.subdomain = window.location.hostname.split('.')[0];

    this.countryCodes = this.$countryCodes;
    if(localStorage.getItem('language')){
      const savedLanguage = localStorage.getItem('language');
      this.selectedLanguage = savedLanguage;
    }


    if(localStorage.getItem('name')) {
      this.customerName = localStorage.getItem('name');
    }else{
      if(localStorage.getItem('customerName')){
        this.customerName = localStorage.getItem('customerName');
      }
      if(localStorage.getItem('customerEmail')){
        this.customerEmail = localStorage.getItem('customerEmail');
      }
      if(localStorage.getItem('customerPhone')){
        this.customerPhone = localStorage.getItem('customerPhone');
      }
      if(localStorage.getItem('selectedCountryCode')){
        this.selectedCountryCode = localStorage.getItem('selectedCountryCode');
      }
    }


    this.getMenu();
  },
  methods: { 
    isPdfByUrl(fileUrl) {
      return fileUrl.toLowerCase().includes('.pdf');
    },
    scrollToActiveCategory() {
      // Encuentra el elemento activo usando el ref y desplázalo al centro
      this.$nextTick(() => {
        const activeElement = this.$refs.categoryItem[this.activeCategory];
        const slider = this.$el.querySelector("#slidericons");

        if (activeElement && slider) {
          const activeElementRect = activeElement.getBoundingClientRect();
          const sliderRect = slider.getBoundingClientRect();

          // Calcula la cantidad que se necesita desplazar para centrar el elemento activo
          const offset =
            activeElementRect.left -
            sliderRect.left -
            sliderRect.width / 2 +
            activeElementRect.width / 2;

          slider.scrollBy({ left: offset, behavior: "smooth" });
        }
      });
    },
    totalPrice() {

      let total = 0;

      this.pendingOrders.forEach(order => {
        this.customerName = order.buyerName
        order.products.forEach(product => {
          if(!order.payed){
            total += product.quantity * product.product.price;
          }
        });
      });
      this.totalPriceOrders = total
      
    },
    labelToPay(){
        return this.$t('toPay')+' '+this.totalPriceOrders+' '+this.currencySymbol;
    },
    localDate(utcDate) {
      const date = new Date(utcDate);
      return format(date, 'PPpp');  // Formato de fecha y hora según la hora local del navegador
    },
    setActiveCategory(key) {
      this.activeCategory = key;
         this.scrollToActiveCategory();
    },
    getTerm(key) {
      const term = this.menu.terms.find(term => term.language === this.selectedLanguage);
      if(!term){
         return this.$t(key);
      }
      return term.values[key] ? term.values[key] : this.$t(key);
    },
    getTranslatedName(item) {
      if (item.nameTranslations == undefined) {
        return item.name
      }

      const translation = item.nameTranslations.find(t => t.language === this.selectedLanguage.toUpperCase());

      return translation && translation.value ? translation.value : item.name;
    },
    getTranslatedDescription(item) {
      if (item.descriptionTranslations == undefined) {
        return item.description
      }
      const translation = item.descriptionTranslations.find(t => t.language === this.selectedLanguage.toUpperCase());

      return translation && translation.value ? translation.value : item.description;
    },
    switchLanguage(code) {
      i18n.locale = this.selectedLanguage;
      localStorage.setItem('language', this.selectedLanguage);
    },
    buttonStyle(color) {
      return {
        backgroundColor: `${color} !important`,
      };
    },
    colorStyle(color) {
      return {
        color: `${color} !important`,
      };
    },
    confirm() {
      let total = this.sum();

      let productListHTML = `<div>`;
      this.cart.forEach(product => {
        productListHTML += `<div class="'+this.stablishment.secondaryColor+'"><small>${product.name} x ${product.quantity}</small></div>`;
      });
      productListHTML += `</div>`;

      let contenttext = `
          <div>
            <p>${this.getTerm('orderDetails')}</p>
            ${productListHTML}
          </div>
        `
      if(this.menu.menuType == 'onsite'){
        contenttext = `
          <div>
            ${productListHTML}
          </div>
        `
      }
  
      if(this.menu.menuType == 'shipping'){
        contenttext = `
          <div>
            Enviaremos tu pedido a la dirección registrada:
            ${this.address.number}  ${this.address.street},  ${this.address.city}  ${this.address.codepostal}  ${this.address.province},  ${this.address.country}
          </div>
        `
      }

      Swal.fire({
        title: this.getTerm('yourOrder'),
        html: contenttext,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: this.stablishment.primaryColor,
        confirmButtonText: this.getTerm('sendOrder') + ' ' + total + this.currencySymbol,
        cancelButtonText: this.getTerm('cancel'),
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.createOrder();
        }
      });
    },
    addItem(item) {
      if (this.opencollapsefirst) {
        this.opencollapse = true;
        this.opencollapsefirst = false;
      }

      item.quantity++;
      const foundItem = this.cart.find(product => product.id === item.id);
      if (foundItem) {
        foundItem.quantity++;
      } else {
        this.cart.push({ ...item, quantity: 1 });
      }
    },
    isValidEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
      return re.test(String(email).toLowerCase());
    },
    async createOrder() {
      try {
        let products = [];
        this.cart.forEach(product => {
          products.push({
            product: product.id,
            quantity: product.quantity
          });
        });
        if(!this.qrId){
          this.qrId = this.$route.params.id
        }  


        localStorage.setItem('customerName',this.customerName);
        localStorage.setItem('customerEmail',this.customerEmail);
        localStorage.setItem('customerPhone',this.customerPhone);
        localStorage.setItem('selectedCountryCode',this.selectedCountryCode);
        
        let params = {
            products,
            menuId: this.menu._id,
            totalPrice: this.sum(),
            comments: this.customerComments,
            buyerName: this.customerName,
            buyerEmail: this.customerEmail,
            buyerPhone: `${this.selectedCountryCode} ${this.customerPhone}`,
            stablishment: this.stablishment,
            qr : this.qrId,
            notificationToken : this.token,
            shippingAddress : this.address
          };
        const response = await createAction(params);
        this.orderId = response.orderId;
  
        if(this.subdomain != 'app'){
          window.location.href = 'https://app.gotake.it/order/'+this.orderId+'-'+this.subdomain;
        }else{
          this.$router.push(`/order/${this.orderId}`);
        }

      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    preventZoom() {
      // Prevenir el zoom solo en los elementos que no tienen la clase 'imagemenu'
      this.$el.addEventListener('dblclick', (event) => {
        if (!event.target.classList.contains('imagemenu')) {
          // Solo se previene el doble clic si no es una imagen del menú
          event.preventDefault();
        }
      }, { passive: false });
    },
    handleDblClick(event) {
      event.preventDefault();
    },
  
    async getMenu() {
      try {

        const response = await menuAction(this.$route.params.id);
        this.menu = response.result.menu;
        if(localStorage.getItem('role') 
          && (localStorage.getItem('role') == 'employee' || localStorage.getItem('role') == 'restaurant') 
          && menu.menuType !== 'imagemenu') {
          //this.menu.menuType = 'onsite'
        }
        this.processMenuData(response.products);
        this.stablishment = response.stablishment;
         if(this.stablishment.primaryColor == '#FFFFFF' ||
        this.stablishment.primaryColor == '#ffffff' || 
        !this.stablishment.primaryColor){
          this.stablishment.primaryColor = '#333';
        }
        if(this.stablishment.secondaryColor == '#FFFFFF' ||
        this.stablishment.secondaryColor == '#ffffff' || 
        !this.stablishment.secondaryColor){
          this.stablishment.secondaryColor = '#333';
        }
        this.business = response.business;
        this.qrName = response.qrName;
        this.menuDisabled = response.menuDisabled;
        this.qrId = response.qrId;
        if(this.menu.menuType == 'onsite'){
           this.pendingOrders = response.pendingOrders
           this.totalPrice();
        }
        this.terms = this.menu.terms
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    processMenuData(products) {
      const categoriesMap = {};
      const categoryNamesSet = new Set();

      products.forEach(product => {
        const categoryId = product.category._id;
        const categoryName = this.getTranslatedName(product.category);

        if (!categoriesMap[categoryId]) {
          categoriesMap[categoryId] = {
            id: categoryId,
            name: categoryName,
            icon: product.category.icon,
            nameTranslations: product.category.nameTranslations,
            products: []
          };
        }

        categoriesMap[categoryId].products.push({
          id: product._id,
          name: product.name,
          nameTranslations: product.nameTranslations,
          descriptionTranslations: product.descriptionTranslations,
          description: product.description || '',
          quantity: 0,
          img: product.images.length > 0 ? product.images[0] : '',
          price: product.price
        });
        categoryNamesSet.add(categoryName);
      });

      this.categories = Object.values(categoriesMap);
      this.categorieslabels = Array.from(categoryNamesSet);
    },
    sum() {
      let total = this.cart.reduce((total, item) => total + (item.price * item.quantity), 0);
      if(this.menu.menuType == 'shipping' && this.business.shippingCostPrice && total > 0){
        total = total + this.business.shippingCostPrice;
      }
      return total.toFixed(2);
    },
    totalitems() {
      return this.cart.reduce((total, item) => total + (item.quantity), 0);
    },
    removeItem(item) {
      if (item.quantity) item.quantity--;

      const index = this.cart.findIndex(product => product.id === item.id);
      if (index !== -1) {
        if (this.cart[index].quantity > 1) {
          this.cart[index].quantity--;
        } else {
          this.cart.splice(index, 1);
        }
      }
    },
    onSelect(items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },    

  },

  mounted() {  
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.preventZoom();
    
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
    this.$el.removeEventListener('dblclick', this.handleDblClick);
  },
};
</script>
<style>

.md-no-head thead{
  display:none !important;
}
</style>

<style scoped>


.paid{
  text-decoration: line-through;
      text-decoration-color:  #419300;
}

.paidlabel{
    font-family: 'Crisp Noto Sans Bold';
    font-style: italic;
    color: #419300;
    display: inline-block;
    transform: rotate(-22deg);
    margin-left: -4px;
    font-size: 10px;
}
</style>

<style lang="css">

.float-right{
  float:right;
}

.anonymoousorder .language-select .md-icon{
  display:none;
}

.anonymoousorder .languages {

   border-radius:50% !important;
    position: absolute;
    right: 0;
    padding: 0px 6px;
    margin: 7px;
    top: 0px;
    z-index: 999;
    background: white;
    width: 38px;
    text-align: left;
}
.anonymoousorder .languages input{
  
    text-transform: uppercase !important;
}

.resumecount,
.resumecount h4 {
  font-family: 'lato'
}


.resumecount.md-card{
      margin-bottom: 0;
    z-index: 99;
}

a {
    color: inherit !important; /* O cualquier otro color que prefieras */
    text-decoration: none  !important; /* Esto quita el subrayado, si no lo quieres */
}

/* Estilo para los enlaces visitados */
a:visited {
    color: inherit !important; /* Mismo color que los enlaces no visitados */
}

#menu .picture{
      max-width: 244px;
}

.titlemenu{
}

.md-field:after {
    height: 0px;
}

.md-field input {
    border-bottom: 1px solid #a2a2a2 !important;
}

.active-category {
  font-weight:bold;
}

#slidericonsinner{
  display: flex; /* Alinear los elementos en línea horizontalmente */
  flex-wrap: nowrap; /* Asegurar que no se vayan a la siguiente línea */
}
#slidericons{
  overflow-x: auto; /* Permitir scroll horizontal */
  white-space: nowrap; /* Impedir que los elementos se alineen verticalmente */
}

.container {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.md-card {
  margin-top: 0;
}

thead {

}
.language-select {
    margin: 10px;
}

.quantity-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.full-height {
  height: 100%;
}

.quantity {
  margin: 0 20px;
  font-size: 16px; /* Puedes ajustar el tamaño de fuente según sea necesario */
}

.large-button {
  width: 40px !important;
  height: 40px !important;
}

.checkout .md-card-content {
}
.checkout .md-card-content h5{
  padding-bottom: 0px !important;
      margin-bottom: 0px;
}
.coverimage{
  border-radius: 0px 0px 30px 30px;
}
.checkout{
}
.container,
.md-layout-item {
  margin-top: 0 !important;
  padding: 0;
  padding-top: 0 !important;
}

.md-toolbar,
.footer {
  display: none;
}
.md-collapse-label {
    padding: 15px 6px 10px 0px;
    cursor: pointer;
    position: relative;
    font-size: 8px;
}
.border-radius{
  
    border-radius: 4px;
}
.languages {
width: 115px;
    position: absolute;
    right: 0;
    border: 1px solid #dddddd;
    padding: 0px 6px;
    margin: 8px;
    top: 0px;
    z-index: 999;
    background: white;
    border-radius: 7px;
        background: white;
}
.languages .md-field{
    margin: 0 !important;
    padding: 0 !important;
    border-radius:4px !important;
}
.languages input{
  border: 0px!important;
  padding: 0px !important;
  font-size: 12px !important;
}
.md-collapse-label:after {
  height:0px !important;
}
.md-collapse-label h5{
  font-size: 1rem !important;}
.md-collapse-label span{
  font-weight:bold;
}
.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* Asegúrate de que el z-index sea mayor que el del resto de los elementos */
  background-color: white; /* Opcional: para asegurarte de que tenga un fondo visible */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Opcional: añade una sombra para destacar el elemento */
  padding: 10px; /* Ajusta el padding según tus necesidades */
}

.pdfembed{
  height:600px !important;
}
.md-collapse-content {
  padding: 0;
}

.md-input{
  width: 100% !important;
}
#collapsetotal i{
  float:right;
}
#collapsetotal  #collapsetotal23 i{
  float:inherit;
}
.language-buttons{
  max-width:100px; 
}
.language-buttons button{
  opacity:0.5;
}
.language-switcher {
  
}


#collapsetotal23 .md-collapse .md-collapse-label .md-icon {
    transform: rotate(360deg) !important;
}
#collapsetotal23 .md-collapse.is-active .md-collapse-label .md-icon {
    transform: rotate(180deg) !important;
}
.logotitle img{
      max-width: 100px;
    margin: 10px;
}
.logotitle{

    text-align: center;
}

#collapsetotal23 span i{
    display:inline;
}

#collapsetotal  button{
      margin-bottom: 18px;
}

.language-buttons .selected{
  font-size: 2em;
  opacity:1;
}

.language-buttons button {
  border: none;
  background: none;
  font-size: 1.5em;
  cursor: pointer;
}
.linkcontainer{
    position: absolute;
    width: auto;
    top: 11px;
    left: 8px;
}
.linkcontainer svg{
    background: white;
    border-radius: 11px;
    padding:2px;
  box-shadow: -1px 1px 8px 1px;
}
.termsanonymous small{
   font-size: 0.5em;
}
.termsanonymous img{
   margin: 0 auto;
}
.linkcontainer span{
    color: black;
    margin: 5px;
}
.logorestocontainer{
  height: 80px !important;
  width:100%;
  text-align:center;  
    margin-top: -40px;
}
.logoresto{
  background-repeat:no-repeat !important;
  background-size:cover !important;
      background-position: center !important;
  height: 80px !important;
  background-color: white !important;
  width: 80px !important;
    border-radius: 40%;
    border: 1px solid #ddd;
    box-shadow: 0px 0px 14px -4px;
    display: inline-block;
}
.language-buttons .selected {
  font-weight: bold;
}
@media screen and (min-width: 500px) {
  .maxwidth{
    max-width:500px !important;
    min-width:500px !important;
    margin: 0 auto;
  }
}

.pschill{
  font-family: 'Font Awesome 5 Free' !important;
}
.pschill .logoresto {
    border-radius: 2px;
    width: 131px !important;
}
</style>
